/** Carpeta del árbol documental. */
export interface Carpeta {
  id: string;
  nombre: string;
  padreId: string | null;
  orden: number;
}

/** Tipo/clasificación del documento. */
export type TipoDocumento =
  | 'politica'
  | 'procedimiento'
  | 'registro'
  | 'certificado'
  | 'licencia'
  | 'contrato'
  | 'capacitacion'
  | 'otro';

/** Documento (metadata). En demo el contenido se guarda en memoria; en backend viene la URL. */
export interface Documento {
  id: string;
  nombre: string;
  nombreArchivo: string;
  carpetaId: string;
  tipoDocumento: TipoDocumento;
  fechaSubida: string;
  fechaVencimiento: string;
  version: number;
  contentType: string;
  tamanoBytes: number;
  /** Solo en demo: contenido en base64 para vista previa y persistencia en navegador. */
  contenidoBase64?: string;
  /** En backend: URL o path del archivo. */
  url?: string;
  observaciones: string;
  createdAt: string;
  updatedAt: string;
}

export const TIPO_DOCUMENTO_LABEL: Record<TipoDocumento, string> = {
  politica: 'Política',
  procedimiento: 'Procedimiento',
  registro: 'Registro',
  certificado: 'Certificado',
  licencia: 'Licencia',
  contrato: 'Contrato',
  capacitacion: 'Capacitación',
  otro: 'Otro',
};

export const TIPOS_DOCUMENTO: TipoDocumento[] = [
  'politica',
  'procedimiento',
  'registro',
  'certificado',
  'licencia',
  'contrato',
  'capacitacion',
  'otro',
];

/** Días antes del vencimiento para considerar "por vencer". */
export const DIAS_ALERTA_VENCIMIENTO = 30;

export function isDocumentoVencido(d: Documento): boolean {
  if (!d.fechaVencimiento) return false;
  return new Date(d.fechaVencimiento) < new Date();
}

export function isDocumentoPorVencer(d: Documento): boolean {
  if (!d.fechaVencimiento) return false;
  const f = new Date(d.fechaVencimiento);
  const hoy = new Date();
  const limite = new Date();
  limite.setDate(limite.getDate() + DIAS_ALERTA_VENCIMIENTO);
  return f >= hoy && f <= limite;
}
